import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/srm/purchase-order/{id}/terminate` → TERMINATED。body：`terminateReason`（必填）、`updatedAt`。 */
export async function terminatePurchaseOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/srm/purchase-order/${id}/terminate`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
